if (!customElements.get('quickbuy-widget')) {
  customElements.define('quickbuy-widget', class QuickbuyWidget extends HTMLElement {
    connectedCallback() {
      const optionNodes = Array.from(this.querySelectorAll('[data-option-select]'));
      this.optionSelects = optionNodes.map(node => node.tagName === 'SELECT' ? node : node.querySelector('select')).filter(Boolean);
      this.mainSelect = this.querySelector('[data-main-select]');
      this.addButton = this.querySelector('[data-action="add-to-cart"]');
      this.sizeSelect = this.pickSizeSelect();
      this.color = this.dataset.color ? this.dataset.color.trim() : '';

      this.handleChange = this.handleChange.bind(this);
      this.addEventListener('change', this.handleChange);

      // Keep main select synced when any option changes
      this.addEventListener('change', () => {
        if (!this.mainSelect) return;
        const selectedValues = Array.from(this.optionSelects).map(select => (select.value || '').trim());
        if (this.color) selectedValues.push(this.color);
        const combinedLabel = selectedValues.join('-');
        Array.from(this.mainSelect.options).forEach(option => {
          const label = (option.innerText || option.textContent || '').trim();
          if (label === combinedLabel) {
            option.setAttribute('selected', 'selected');
            this.mainSelect.value = option.value;
          } else {
            option.removeAttribute('selected');
          }
        });
      });

      this.syncVariant();
      this.updateAddButtonState();
      this.autoselectFromCart();
    }

    pickSizeSelect() {
      const byName = this.optionSelects.find(select => /size/i.test(select.name || select.id || ''));
      if (byName) return byName;
      return this.optionSelects.find(select => select.querySelector('option[data-select-reminder]')) || null;
    }

    handleChange() {
      this.syncVariant();
      this.updateAddButtonState();
    }

    syncVariant() {
      if (!this.mainSelect) return;
      const selectedValues = this.optionSelects.map(select => (select.value || '').trim());
      if (this.color) selectedValues.push(this.color);
      const combinedLabel = selectedValues.join('-').trim();

      const mainOptions = Array.from(this.mainSelect.options || []);
      let matchedOption = null;

      for (const option of mainOptions) {
        const label = (option.textContent || '').trim();
        option.selected = label === combinedLabel;
        if (option.selected) matchedOption = option;
      }

      if (matchedOption) this.mainSelect.value = matchedOption.value;
    }

    updateAddButtonState() {
      if (!this.addButton) return;
      let shouldDisable = false;

      for (const select of this.optionSelects) {
        const selectedIndex = select.selectedIndex;
        const selectedOption = selectedIndex >= 0 ? select.options[selectedIndex] : null;
        if (!selectedOption || selectedOption.disabled || selectedOption.hasAttribute('data-select-reminder')) {
          shouldDisable = true;
          break;
        }
      }

      this.addButton.disabled = shouldDisable;
    }

    selectReminderOption() {
      if (!this.sizeSelect) return;
      const reminderOption = this.sizeSelect.querySelector('option[data-select-reminder]');
      if (!reminderOption) return;
      reminderOption.selected = true;
      this.sizeSelect.value = reminderOption.value;
      this.sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    async autoselectFromCart() {
      let cartData;
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        cartData = await response.json();
      } catch { return; }

      const cartItems = Array.isArray(cartData?.items) ? cartData.items : [];
      const validCategories = new Set(['footwear', 'insole', 'sock']);
      let firstFoundSize = null;
      let mixedSizes = false;
      let foundAny = false;

      for (const item of cartItems) {
        const category = String(item?.properties?._category || '').toLowerCase();
        if (!validCategories.has(category)) continue;

        const rawSizeValue = item?.options_with_values?.[0]?.value;
        const size = rawSizeValue == null ? '' : String(rawSizeValue).trim();

        if (!size) { mixedSizes = true; break; }

        if (!foundAny) {
          firstFoundSize = size;
          foundAny = true;
        } else if (firstFoundSize !== size) {
          mixedSizes = true;
          break;
        }
      }

      if (!foundAny || mixedSizes) {
        this.selectReminderOption();
        this.updateAddButtonState();
        return;
      }

      if (!this.sizeSelect) return;

      const matchedSizeOption = Array.from(this.sizeSelect.options || [])
        .find(optionEl => String(optionEl.value).trim() === firstFoundSize);

      if (!matchedSizeOption || matchedSizeOption.disabled) {
        this.selectReminderOption();
        this.updateAddButtonState();
        return;
      }

      this.sizeSelect.value = matchedSizeOption.value;
      this.sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncVariant();
      this.updateAddButtonState();
    }
  });
}
